import { useFormikContext } from "formik";
import { getImageSizes, getSrcSet, metaobject, shapes } from "../../Helpers/WindowHelpers";
import DimensionDisplay from "./DimensionDisplay";
import Image from "./Image";

interface ConfiguratorDisplayInterface {


}
const ConfiguratorDisplay = () => {
    const context = useFormikContext<any>();
    const currentShape = shapes?.find((shape) => shape.shape_id == context.values?.shape);
    const srcSets = [450, 520, 900, 1040];
    const imageSizes = getImageSizes('450px', [{ screen: 1664, view: '520px' }]);
    const foldDirection = currentShape?.panels?.find((panel) => panel.number_of_panels == context.values?.panels)?.fold_directions?.find((fold) => fold.option_select_name == context.values?.fold_direction);
    const strapLocation = foldDirection?.strap_locations?.find((strap) => strap.option_select_name == context.values?.strap_location);
    return (
        <div className="configurator-display">
            <div className="configurator-display__layer ratio ratio--square configurator-display__material">
                {context.values?.color?.image ? (
                    <img
                        srcSet={getSrcSet(context.values?.color?.image, srcSets)}
                        sizes={imageSizes}
                        src={context.values.color.image}
                        loading="lazy"
                        alt={context.values.color.name}
                    />
                ) : null}
            </div>
            <div className="configurator-display__layer ratio ratio--square">
                <DimensionDisplay dimension="a" currentShape={currentShape} />
                <DimensionDisplay dimension="b" currentShape={currentShape} />
                <DimensionDisplay dimension="c" currentShape={currentShape} />
                <DimensionDisplay dimension="d" currentShape={currentShape} />
                <div className="configurator-display__shape ratio ratio--square">
                    <img
                        srcSet={getSrcSet(currentShape ? currentShape.image.src : metaobject.shape_placeholder_image, srcSets)}
                        sizes={imageSizes}
                        loading="lazy"
                        alt={currentShape ? currentShape.name : "Shape Placeholder Image. Please select a shape."}
                    />
                </div>
            </div>
            <div className="configurator-display__layer ratio ratio--square configurator-display__strap-location">
                {strapLocation && strapLocation.image.src ? (
                    <Image image={strapLocation.image} srcSet={srcSets} sizes={imageSizes} />
                ) : null}
            </div>
            <div className="configurator-display__layer ratio ratio--square configurator-display__fold-direction">
                {foldDirection && foldDirection.image.src ? (
                    <Image image={foldDirection.image} srcSet={srcSets} sizes={imageSizes} />
                ) : null}
            </div>
            <div className="configurator-display__layer ratio ratio--square configurator-display__handles">
                {foldDirection && foldDirection.default_handle_location.src ? (
                    <Image image={foldDirection.default_handle_location} srcSet={srcSets} sizes={imageSizes} />
                ) : null}
            </div>
        </div>
    );
}

export default ConfiguratorDisplay;